"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledGridHeaderCellWithResizeTriggerControl = exports.StyledGridHeaderCellWithResizeTrigger = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const sizing_1 = require("../../../../../design/constants/sizing");
const base_1 = require("../../../../../design/themes/base");
exports.StyledGridHeaderCellWithResizeTrigger = styled_components_1.default.div `
    position: relative;
    flex-grow: 1;
    display: flex;
    align-self: center;
    align-items: center;
    min-width: 0;
`;
exports.StyledGridHeaderCellWithResizeTriggerControl = styled_components_1.default.div `
    position: absolute;
    z-index: 2;
    top: 0;
    bottom: 0;
    right: 0;
    width: ${sizing_1.sizing.sizeSpaceS.var()};
    cursor: col-resize;

    &:hover {
        background-color: ${base_1.baseTheme.colorHighlightDark.var()};
    }

    &:active {
        background-color: ${base_1.baseTheme.colorHighlightDark.var()};
    }
`;
//# sourceMappingURL=GridHeaderCellWithResizeTrigger.styles.js.map